import { useaxios } from "../../../utils/useaxios";
export default (datte) => recaller => setrecaller => initDispatch => clear => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() + " " + today.getHours() + ":" + today.getMinutes() + ":" + today.getMinutes();
    // initDispatch({ type: 'loadingTrue' });
    useaxios('sell_invoice/read.php', { datte }).then((res) => {
        if (res == "auth_failed") {
            alert('no internet connection');
            return false;
        }
        if (res.status == "ok") {
            initDispatch({ type: 'setsellinvoice', payload: res.today_invoice })
            // setrecaller(recaller + 1);
        } else {
            // clear();
        }
        // setloading(false);
    });
}